<template>
  <el-date-picker
    v-model="data"
    :default-value="defaultData"
    :size="size"
    :format="format"
    :value-format="valueFormat"
    :readonly="readonly"
    :type="type"
    :align="align"
    :disabled="disabled"
    :unlink-panels="unlinkPanels"
    :range-separator="rangeSeparator"
    :start-placeholder="startPlaceholderFormat"
    :end-placeholder="endPlaceholderFormat"
    :picker-options="pickerOptions"
    :clearable="clearable"
    @change="change">
  </el-date-picker>
</template>

<script>
import { prevMonth, getNowFormatDate, toRawType } from '@/assets/js/common.js'
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    size: String,
    format: String,
    valueFormat: String,
    readonly: Boolean,
    placeholder: String,
    startPlaceholder: String,
    endPlaceholder: String,
    prefixIcon: String,
    type: {
      type: String,
      default: 'date'
    },
    clearIcon: {
      type: String,
      default: 'el-icon-circle-close'
    },
    disabled: Boolean,
    clearable: {
      type: Boolean,
      default: true
    },
    popperClass: String,
    editable: {
      type: Boolean,
      default: true
    },
    align: {
      type: String,
      default: 'left'
    },
    value: {},
    defaultValue: {},
    defaultTime: {},
    rangeSeparator: {
      default: '-'
    },
    pickerOptions: {},
    unlinkPanels: Boolean
  },
  computed: {
    defaultData () {
      return prevMonth()
    },
    startPlaceholderFormat () {
      let str = this.startPlaceholder
      if (this.value && (toRawType(this.value) == 'Array' ? this.value[0] : true)) {
        if (toRawType(this.value[0]) == 'Date') {
          str = getNowFormatDate(this.value[0])
        } else if (toRawType(this.value[0]) == 'String') {
          str = this.value[0]
        }
      }
      return str
    },
    endPlaceholderFormat () {
      let str = this.endPlaceholder
       if (this.value && (toRawType(this.value) == 'Array' ? this.value[1] : true)) {
        if (toRawType(this.value[1]) == 'Date') {
          str = getNowFormatDate(this.value[1])
        } else if (toRawType(this.value[1]) == 'String') {
          str = this.value[1]
        }
      }
      return str
    }
  },
  data () {
    return {
      data: []
    }
  },
  watch: {
    value (val) {
      this.data = val
    }
  },
  methods: {
    change (val) {
      this.$emit('change', val)
    }
  }
}
</script>

<style>

</style>